import { FC } from 'react';
import { useDismissGlobalNotifications, useGlobalNotifications } from './useGlobalNotifications';
import {
   AlertIcon,
   Alert,
   AlertDescription,
   CloseButton,
   VStack,
   HStack,
   Text,
} from '@chakra-ui/react';
import { useFormatRelativeDate } from '~/ui-components';

export const Announcements: FC = () => {
   const { data } = useGlobalNotifications();
   const mutation = useDismissGlobalNotifications();
   const formatRelativeDate = useFormatRelativeDate();

   if (!data || data.notifications.length === 0) {
      return null;
   }

   function onClose() {
      mutation.mutate();
   }

   return (
      <Alert status="warning" justifyContent="center" position="relative">
         <VStack alignItems="flex-start" spacing={5}>
            {data.notifications.map(notification => (
               <HStack key={notification.notificationid}>
                  <AlertIcon />
                  <AlertDescription maxW={['80%', '90%', null, null, '1000px']}>
                     <Text fontSize="md">{notification.message}</Text>
                     <Text as="em" fontSize="xs">
                        {formatRelativeDate(notification.posted)}
                     </Text>
                  </AlertDescription>
               </HStack>
            ))}
         </VStack>
         <CloseButton position="absolute" right={1} top={1} onClick={onClose} />
      </Alert>
   );
};
